import React, { useEffect, useState } from 'react';
import DocumentWidget from '@components/widgets/document-widget/DocumentWidget';
import EnhancedButton from '@components/button/EnhancedButton';
import { IFileCardProps } from '@models/file';
import AddTreatyDocumentDrawer from '../add-treaty-document-drawer/AddTreatyDocumentDrawer';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { getTreatyDocumentsQuery } from './queries';
import Loader from '@components/loader/Loader';
import { mapFileToDocumentWidgetFiles } from './utils';
import { CDN_URL } from '@utils';

const TreatyDocuments: React.FC = () => {
  const { id: currentTreatyId } = useParams<{ id: string }>();
  const [showAddDrawer, setShowAddDrawer] = useState<boolean>(false);

  const [documentsData, setDocumentsData] = useState<IFileCardProps[]>();

  const { refetch, data, loading } = useQuery(getTreatyDocumentsQuery, {
    variables: { TreatyID: currentTreatyId },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    const docsList = mapFileToDocumentWidgetFiles(
      data?.Production?.queries?.GetTreatyDocuments
    );

    setDocumentsData(docsList);
  }, [data]);

  return loading ? (
    <Loader />
  ) : (
    <>
      <DocumentWidget
        title="Supporting Documents"
        cdnUrl={CDN_URL}
        files={documentsData}
        actions={
          <EnhancedButton
            isPrimary={false}
            onClick={() => setShowAddDrawer(true)}
          >
            Add Document
          </EnhancedButton>
        }
      />

      {showAddDrawer && (
        <AddTreatyDocumentDrawer
          currentTreatyId={currentTreatyId}
          isOpen={showAddDrawer}
          onClose={() => setShowAddDrawer(false)}
          onSuccess={() => refetch()}
        />
      )}
    </>
  );
};

export default TreatyDocuments;
